import { render, staticRenderFns } from "./DeleteAttachmentModal.vue?vue&type=template&id=2d10880e&scoped=true&"
import script from "./DeleteAttachmentModal.vue?vue&type=script&lang=ts&"
export * from "./DeleteAttachmentModal.vue?vue&type=script&lang=ts&"
import style0 from "./DeleteAttachmentModal.vue?vue&type=style&index=0&id=2d10880e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d10880e",
  null
  
)

export default component.exports